<template>
  <div>
    <div class="w3-container">
      <div class="headerGridCMS w3-hide-print">
        <div>
          <header>
            <h2><template v-if="$route.params.slug">Edit</template><template v-else>New</template> Unit</h2>
          </header>
        </div>
        <div>
          <button class='w3-button w3-right w3-small vmiddle w3-red' style="margin-left:8px;" @click="exit()">Exit</button>
          <button class='w3-button w3-right w3-small vmiddle' :class="saving || saved ? 'w3-dark-teal' : 'w3-teal'" :disabled="saving || saved" @click="saveContent()"><span v-if="!saved">Save Unit</span><span v-if="saved">Unit Saved</span></button>
        </div>
      </div>
      <div class="unitDetailGrid">
        <div>
          <div class="inputCard">
            <header class="w3-left-align">Main</header>
            <div class="content">
              <!-- Title -->
              <div class="cardRow w3-padding-8">
                <label>Unit # / Identifier</label>
                <input v-model="unit.title" class="w3-input w3-border" />
              </div>
              <!-- Property -->
              <div class="cardRow w3-padding-8">
                <label>Property</label>
                <select class="w3-select w3-border" v-model="unit.property">
                  <option v-for="(property, index) in state.siteData.content.properties.items" :key="index" :value="property.title">{{property.title}}</option>
                </select>
              </div>
              <!-- Location -->
              <div class="cardRow w3-padding-8">
                <label>Location / Address</label>
                <input v-model="unit.location" class="w3-input w3-border" />
              </div>
            </div>
          </div>
          <!-- Description -->
          <div class="inputCard w3-padding-top">
            <header class="w3-left-align">Unit Description</header>
            <div class="content">
              <div class="input-row w3-padding-8">
                <tinymce-editor api-key="t5p4kok2r7znye5exinvmcmpazco8x8rd3hoapujd41dps8c" :init="state.tinymceInit" v-model="unit.description"></tinymce-editor>
              </div>
            </div>
          </div>
          <div class="inputCard">
            <header class="w3-left-align">Features</header>
            <div class="content">
              <div class="featureAddGrid">
                <div>
                  <input class="w3-input w3-border" style="font-size:11pt; margin:4px;" placeholder="Add feature text..." v-model="newFeature" />
                </div>
                <div style="padding-right:4px;">
                  <button class="w3-button w3-small w3-green vmiddle w3-block" style="padding:5px 16px;" @click="saveFeature()">Add</button>
                </div>
              </div>
              <div v-for="(feature, index) in unit.features" :key="index">
                <div class="w3-padding-8">
                  <i class="fa fa-bullseye w3-small" style="margin-right:8px;"></i>{{feature}}
                  <div class="w3-right">
                    <button class="w3-button w3-small w3-red" style="padding:5px 12px; margin-top:-4px;" @click="deleteFeature(index)"><i class="fa fa-trash"></i></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Images -->
          <div class="inputCard">
            <header class="w3-left-align">Images</header>
            <div class="content unitImagesGrid">
              <div class="w3-dark-grey w3-padding-top">
                <div class="w3-center w3-padding-bottom">
                  <img v-if="unit.image1.src !== ''" :src="unit.image1.src" style="width:100%; max-width:300px;" />
                  <img v-if="unit.image1.src === ''" src="https://levelsevenstudio.com/frontend/img/demos/real-estate/listings/listing-1.jpg" style="width:100%; max-width:300px;" />
                </div>
                <div class="cardRow w3-padding">
                  <label>Image One</label>
                  <div class="w3-right-align">
                    <button v-if="unit.image1.src !== ''" class="w3-button w3-red w3-round w3-small" @click="unit.image1.src = ''"><i class="fa fa-trash"></i></button>
                    <label for="unitFile" class="w3-button w3-green w3-small" style="margin-top:0;">Upload Image</label>
                    <input id="unitFile" type="file" @change="uploadUnitImage($event.target.files, 'image1')" ref="fileUpload" accept=".png,.jpg" class="inputFile" />
                  </div>
                </div>
              </div>
              <div class="w3-dark-grey w3-padding-top">
                <div class="w3-center w3-padding-bottom">
                  <img v-if="unit.image2.src !== ''" :src="unit.image2.src" style="width:100%; max-width:300px;" />
                  <img v-if="unit.image2.src === ''" src="https://levelsevenstudio.com/frontend/img/demos/real-estate/listings/listing-1.jpg" style="width:100%; max-width:300px;" />
                </div>
                <div class="cardRow w3-padding">
                  <label>Image Two</label>
                  <div class="w3-right-align">
                    <button v-if="unit.image2.src !== ''" class="w3-button w3-red w3-round w3-small" @click="unit.image2.src = ''"><i class="fa fa-trash"></i></button>
                    <label for="unitFile2" class="w3-button w3-green w3-small" style="margin-top:0;">Upload Image</label>
                    <input id="unitFile2" type="file" @change="uploadUnitImage($event.target.files, 'image2')" ref="fileUpload2" accept=".png,.jpg" class="inputFile" />
                  </div>
                </div>
              </div>
              <div class="w3-dark-grey w3-padding-top">
                <div class="w3-center w3-padding-bottom">
                  <img v-if="unit.image3.src !== ''" :src="unit.image3.src" style="width:100%; max-width:300px;" />
                  <img v-if="unit.image3.src === ''" src="https://levelsevenstudio.com/frontend/img/demos/real-estate/listings/listing-1.jpg" style="width:100%; max-width:300px;" />
                </div>
                <div class="cardRow w3-padding">
                  <label>Image Three</label>
                  <div class="w3-right-align">
                    <button v-if="unit.image3.src !== ''" class="w3-button w3-red w3-round w3-small" @click="unit.image3.src = ''"><i class="fa fa-trash"></i></button>
                    <label for="unitFile3" class="w3-button w3-green w3-small" style="margin-top:0;">Upload Image</label>
                    <input id="unitFile3" type="file" @change="uploadUnitImage($event.target.files, 'image3')" ref="fileUpload3" accept=".png,.jpg" class="inputFile" />
                  </div>
                </div>
              </div>
              <div class="w3-dark-grey w3-padding-top">
                <div class="w3-center w3-padding-bottom">
                  <img v-if="unit.image4.src !== ''" :src="unit.image4.src" style="width:100%; max-width:300px;" />
                  <img v-if="unit.image4.src === ''" src="https://levelsevenstudio.com/frontend/img/demos/real-estate/listings/listing-1.jpg" style="width:100%; max-width:300px;" />
                </div>
                <div class="cardRow w3-padding">
                  <label>Image Four</label>
                  <div class="w3-right-align">
                    <button v-if="unit.image4.src !== ''" class="w3-button w3-red w3-round w3-small" @click="unit.image4.src = ''"><i class="fa fa-trash"></i></button>
                    <label for="unitFile4" class="w3-button w3-green w3-small" style="margin-top:0;">Upload Image</label>
                    <input id="unitFile4" type="file" @change="uploadUnitImage($event.target.files, 'image4')" ref="fileUpload4" accept=".png,.jpg" class="inputFile" />
                  </div>
                </div>
              </div>
              <div class="w3-dark-grey w3-padding-top">
                <div class="w3-center w3-padding-bottom">
                  <img v-if="unit.image5.src !== ''" :src="unit.image5.src" style="width:100%; max-width:300px;" />
                  <img v-if="unit.image5.src === ''" src="https://levelsevenstudio.com/frontend/img/demos/real-estate/listings/listing-1.jpg" style="width:100%; max-width:300px;" />
                </div>
                <div class="cardRow w3-padding">
                  <label>Image Five</label>
                  <div class="w3-right-align">
                    <button v-if="unit.image5.src !== ''" class="w3-button w3-red w3-round w3-small" @click="unit.image5.src = ''"><i class="fa fa-trash"></i></button>
                    <label for="unitFile5" class="w3-button w3-green w3-small" style="margin-top:0;">Upload Image</label>
                    <input id="unitFile5" type="file" @change="uploadUnitImage($event.target.files, 'image5')" ref="fileUpload5" accept=".png,.jpg" class="inputFile" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Documents -->
          <div class="inputCard">
            <header class="w3-left-align">Documents</header>
            <div class="content unitImagesGrid">
              <div class="w3-dark-grey w3-padding-top">
                <div class="w3-center w3-padding" v-if="unit.doc1.src !== ''">
                  <i class="fa fa-file" style="font-size: 64px;"></i><br/>
                  <span>PDF</span>
                </div>
                <div class="cardRow w3-padding">
                  <label>Doc One</label>
                  <div class="w3-right-align">
                    <button v-if="unit.doc1.src !== ''" class="w3-button w3-red w3-round w3-small" @click="unit.doc1.src = ''"><i class="fa fa-trash"></i></button>
                    <label for="propertyDoc1" class="w3-button w3-green w3-small" style="margin-top:0;">Upload Doc</label>
                    <input id="propertyDoc1" type="file" @change="uploadUnitDoc($event.target.files, 'doc1')" ref="fileUpload" accept=".pdf" class="inputFile" />
                  </div>
                </div>
                <div class="cardRow w3-padding">
                  <label>Title</label>
                  <input v-model="unit.doc1.title" class="w3-input w3-border" />
                </div>
              </div>
              <div class="w3-dark-grey w3-padding-top">
                <div class="w3-center w3-padding-bottom" v-if="unit.doc2.src !== ''">
                  <i class="fa fa-file" style="font-size: 64px;"></i><br/>
                  <span>PDF</span>
                </div>
                <div class="cardRow w3-padding">
                  <label>Doc Two</label>
                  <div class="w3-right-align">
                    <button v-if="unit.doc2.src !== ''" class="w3-button w3-red w3-round w3-small" @click="unit.doc2.src = ''"><i class="fa fa-trash"></i></button>
                    <label for="propertyDoc2" class="w3-button w3-green w3-small" style="margin-top:0;">Upload Doc</label>
                    <input id="propertyDoc2" type="file" @change="uploadUnitDoc($event.target.files, 'doc2')" ref="fileUpload2" accept=".pdf" class="inputFile" />
                  </div>
                </div>
                <div class="cardRow w3-padding">
                  <label>Title</label>
                  <input v-model="unit.doc2.title" class="w3-input w3-border" />
                </div>
              </div>
              <div class="w3-dark-grey w3-padding-top">
                <div class="w3-center w3-padding-bottom" v-if="unit.doc3.src !== ''">
                  <i class="fa fa-file" style="font-size: 64px;"></i><br/>
                  <span>PDF</span>
                </div>
                <div class="cardRow w3-padding">
                  <label>Doc Three</label>
                  <div class="w3-right-align">
                    <button v-if="unit.doc3.src !== ''" class="w3-button w3-red w3-round w3-small" @click="unit.doc3.src = ''"><i class="fa fa-trash"></i></button>
                    <label for="propertyDoc3" class="w3-button w3-green w3-small" style="margin-top:0;">Upload Doc</label>
                    <input id="propertyDoc3" type="file" @change="uploadUnitDoc($event.target.files, 'doc3')" ref="fileUpload3" accept=".pdf" class="inputFile" />
                  </div>
                </div>
                <div class="cardRow w3-padding">
                  <label>Title</label>
                  <input v-model="unit.doc3.title" class="w3-input w3-border" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="inputCard">
            <header>Details</header>
            <div class="content">
              <template v-if="checkPropertyType(unit.property) === 'commercial'">
                <div class="cardRow w3-padding-8">
                  <label>SQ FT</label>
                  <input class="w3-input w3-border roboto" style="padding-bottom:1px;" type="number" step="1" placeholder="2,000" v-model="unit.sqft" />
                </div>
                <div class="cardRow w3-padding-8">
                  <label>Price</label>
                  <input class="w3-input w3-border roboto" style="padding-bottom:1px;" type="number" step=".01" placeholder="1,800" v-model="unit.price" @input="calcTotal()" />
                </div>
                <div class="cardRow w3-padding-8">
                  <label>CAM</label>
                  <input class="w3-input w3-border roboto" style="padding-bottom:1px;" type="number" step=".01" placeholder="350" v-model="unit.cam" @input="calcTotal()" />
                </div>
                <div class="cardRow w3-padding-8">
                  <label>Tax</label>
                  <input class="w3-input w3-border roboto" style="padding-bottom:1px;" type="number" step=".01" placeholder="120" v-model="unit.tax" @input="calcTotal()" />
                </div>
                <div class="cardRow w3-padding-8">
                  <label>Total</label>
                  <input disabled class="w3-input w3-border roboto" style="padding-bottom:1px;" v-model="unit.total" />
                </div>
                <div class="cardRow w3-padding-8">
                  <label>Status</label>
                  <div class="w3-right-align">
                    <label class="switch">
                      <input type="checkbox" v-model="unit.status">
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
              </template>
              <template v-if="checkPropertyType(unit.property) === 'residential'">
                <div class="cardRow w3-padding-8">
                  <label>SQ FT</label>
                  <input class="w3-input w3-border roboto" style="padding-bottom:1px;" type="number" step="1" placeholder="2,000" v-model="unit.sqft" />
                </div>
                <div class="cardRow w3-padding-8">
                  <label>Beds</label>
                  <input class="w3-input w3-border roboto" style="padding-bottom:1px;" type="number" step="0.5" placeholder="2" v-model="unit.beds" />
                </div>
                <div class="cardRow w3-padding-8">
                  <label>Baths</label>
                  <input class="w3-input w3-border roboto" style="padding-bottom:1px;" type="number" step="0.5" placeholder="1.5" v-model="unit.baths" />
                </div>
                <div class="cardRow w3-padding-8">
                  <label>Price</label>
                  <input class="w3-input w3-border roboto" style="padding-bottom:1px;" type="number" step=".01" placeholder="1,800" v-model="unit.price" @input="calcTotal()" />
                </div>
                <div class="cardRow w3-padding-8">
                  <label>Total</label>
                  <input disabled class="w3-input w3-border roboto" style="padding-bottom:1px;" v-model="unit.total" />
                </div>
                <div class="cardRow w3-padding-8">
                  <label>Status</label>
                  <div class="w3-right-align">
                    <label class="switch">
                      <input type="checkbox" v-model="unit.status">
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
              </template>
              <template v-if="checkPropertyType(unit.property) === 'land'">
                <div class="cardRow w3-padding-8">
                  <label>Price</label>
                  <input class="w3-input w3-border roboto" style="padding-bottom:1px;" type="number" step=".01" placeholder="1,800" v-model="unit.price" @input="calcTotal()" />
                </div>
                <div class="cardRow w3-padding-8">
                  <label>Acres</label>
                  <input class="w3-input w3-border" type="number" step="0.01" placeholder="2.21" v-model="unit.acres" />
                </div>
                <div class="cardRow w3-padding-8">
                  <label>Zoning</label>
                  <input class="w3-input w3-border" type="text" v-model="unit.zoning" />
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
var slug = require('slug')
var dataStore = require('../../dataStore').default

export default {
  name: 'cmspropertiesunitsdetail',
  data() {
    return {
      state: dataStore.state,
      unit: {
        image1: {
          src: ''
        },
        image2: {
          src: ''
        },
        image3: {
          src: ''
        },
        image4: {
          src: ''
        },
        image5: {
          src: ''
        },
        doc1: {
          src: '',
          title: ''
        },
        doc2: {
          src: '',
          title: ''
        },
        doc3: {
          src: '',
          title: ''
        },
      },
      newFeature: '',
      saving: false,
      saved: false
    }
  },
  components: {
    'tinymce-editor': Editor
  },
  created() {
    this.init()
    if (this.$route.params.slug) {
      for (let savedUnit of this.state.siteData.content.properties.units) {
        if (this.$route.params.slug === savedUnit.url) {
          Object.assign(this.unit, savedUnit)
          // console.log(this.unit)
          break
        }
      }
    }
  },
  methods: {
    init() {
      this.unit = {
        title: '',
        subtitle: '',
        type: 'residential',
        sqft: '',
        price: '',
        cam: '',
        tax: '',
        total: 0,
        image1: {
          src: ''
        },
        image2: {
          src: ''
        },
        image3: {
          src: ''
        },
        image4: {
          src: ''
        },
        image5: {
          src: ''
        },
        doc1: {
          src: '',
          title: ''
        },
        doc2: {
          src: '',
          title: ''
        },
        doc3: {
          src: '',
          title: ''
        },
        features: [],
        url: '',
        status: true
      }
    },
    calcTotal() {
      let subtotal = parseFloat(this.unit.price ? this.unit.price : 0) + parseFloat(this.unit.cam ? this.unit.cam : 0)
      this.unit.total = '$' + (subtotal + parseFloat(this.unit.tax ? this.unit.tax : 0)).toFixed(2)
    },
    uploadUnitImage(files, which) {
      dataStore.uploadImage(files).then((path) => {
        this.unit[which].src = path
      })
    },
    uploadUnitDoc(files, which) {
      dataStore.uploadDoc(files).then((path) => {
        this.unit[which].src = path
      })
    },
    saveContent() {
      this.unit.url = slug(this.unit.property + '-' + this.unit.title)
      let loopIndex = 0
      let found = false
      for (let savedUnit of this.state.siteData.content.properties.units) {
        if (savedUnit.url === this.unit.url) {
          if (!confirm('Unit exists, overwrite?')) {
            return
          } else {
            found = true
            break
          }
        }
        loopIndex++
      }
      if (found) {
        this.state.siteData.content.properties.units[loopIndex] = this.unit
      } else {
        this.state.siteData.content.properties.units.push(this.unit)
      }
      this.saving = true
      dataStore.saveSiteData().then((res) => {
        this.saving = false
        if (res === 'success') {
          this.$router.replace('/cms/properties')
        }
      })
    },
    saveFeature() {
      this.unit.features.push(this.newFeature)
      this.newFeature = ''
    },
    deleteFeature(index) {
      this.unit.features.splice(index, 1)
    },
    checkPropertyType(propertyName) {
      for (let property of this.state.siteData.content.properties.items) {
        // console.log(property)
        if (property.title === propertyName) {
          return property.type
        }
      }
    },
    exit() {
      this.init()
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
  .newsTitle {font-size:1rem;}
  .newsMeta {font-size:1rem; font-family: 'Roboto', sans-serif; text-align: center;}
  .newsGrid {display:grid; grid-template-columns: 225px 1fr; grid-gap: 8px; border-bottom: 1px solid #ccc;}
  .newsGrid:last-child {border-bottom:0;}
  .newsContentGrid {display:grid; grid-template-columns: 1fr 250px 130px; grid-gap: 8px;}
  .buttons {text-align: right;}
  header.w3-left-align {padding-left:12px;}

  .featureAddGrid {display: grid; grid-template-columns: 1fr 80px; grid-gap: 8px;}

  .unitDetailGrid {display:grid; grid-template-columns: 3fr 1fr; grid-gap: 8px;}
  .unitImagesGrid {display:grid; grid-template-columns: repeat(3, 1fr); grid-gap: 8px;}

@media screen and (max-width:993px) {
  .newsTitle {font-size:10pt;}
  .newsMeta {font-size:10pt; font-family: 'Roboto', sans-serif;}
  .newsGrid {display:grid; grid-template-columns: 125px 1fr; grid-gap: 8px;}
}
</style>



// WEBPACK FOOTER //
// src/components/cms/cmsPropertiesUnitsDetail.vue